export default "__VITE_ASSET__CcqCBzTX__"